"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sberbank(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.0108 5.151L17.7195 5.7945L8.7705 10.9035L4.4385 8.40975L4.8435 7.605L8.7705 9.83775L17.0108 5.15025V5.151ZM15.2093 4.125L16.1603 4.608L8.7705 8.832L5.3295 6.8805L5.916 6.177L8.7705 7.806L15.21 4.125H15.2093ZM18.3473 6.45825L18.873 7.1625L8.7705 12.9352L3.89175 10.1595L4.1145 9.2745L8.7705 11.9295L18.3473 6.45825ZM19.8045 9.05325C20.1015 9.885 20.25 10.7557 20.25 11.6677C20.25 12.5797 20.1015 13.4655 19.8045 14.3228L19.602 14.8665C19.1862 15.8418 18.5885 16.7291 17.841 17.481C17.0846 18.2237 16.1903 18.8115 15.2085 19.2113C14.1698 19.6537 13.0973 19.875 11.9903 19.875C10.8698 19.875 9.7965 19.6537 8.7705 19.2113C7.80038 18.8012 6.91487 18.2145 6.159 17.481C5.40287 16.7362 4.80403 15.8471 4.398 14.8665C3.9705 13.854 3.74925 12.7665 3.75 11.6677V11.1248L8.7705 13.9613L19.359 7.92675L19.8045 9.05325Z", fill: color }));
}
exports["default"] = sberbank;
//# sourceMappingURL=sberbank.js.map